import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/chevron-right.svg";
var ChevronRightSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  ChevronRightSolid_default as default
};
